<script>
    import {onMount} from "svelte";
    import Common from "../public/lib/common";
    import jQuery from 'jquery';

    export let number;
    export let title;

    let id = Common.randomString();

    onMount(async () => {
        let w = jQuery('#' + id).width();
        jQuery('#' + id).css({'height': w/2 + 'px'});
    });


</script>


<div id="{id}" class="text-center flex flex-col chart-container" >
    <span class="text-6xl flex items-center justify-center h-full" >{number}</span><br>
    <span class="text-lg pb-4">{title}</span>
</div>

<style>

</style>
